//  NEEDS SEPARATION

import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

// Styles
import TitleWrapper, { TitleWrapperPropTypes } from "./styles/TitleWrapper";
import PageSectionWrapper from "./styles/PageSectionWrapper";
import ChildContentWrapper from "./styles/ChildContentWrapper";

// Components
import ButtonStyled from "../modernized/Buttons/ButtonStyled";
import Video from "../obsolete/Modal/Video";

const MediaWrapper = styled.div`
    label: MediaWrapper;

    padding: 0;
    margin: 0;
    text-align: center;
    //Mobile-landscape (and larger)
    @media (min-width: 320px) {
        min-width: 100%;
    }
    //Mobile-landscape (and larger)
    @media (min-width: 480px) {
        min-width: 100%;
    }
    // Tablet-portrait (and larger)
    @media (min-width: 768px) {
        min-width: 100%;
    }
    // Tablet-landscape (and larger)
    @media (min-width: 992px) {
        min-width: 60%;
    }
    // Laptops (and longer)
    @media (min-width: 1200px) {
        min-width: 40%;
        max-height: 30%;
        img {
            min-width: auto;
            max-width: 100%;
        }
    }
`;
const ContentWrapper = styled.div`
    label: ContentWrapper;

    padding: 20px;
    width: 100%;

    //Mobile-landscape (and larger)
    @media (min-width: 320px) {
        text-align: center;
    }
    //Mobile-landscape (and larger)
    @media (min-width: 480px) {
        text-align: center;
    }
    // Tablet-portrait (and larger)
    @media (min-width: 768px) {
        text-align: center;
    }
    // Tablet-landscape (and larger)
    @media (min-width: 992px) {
        text-align: center;
    }
    // Laptops (and longer)
    @media (min-width: 1200px) {
        text-align: left;
    }
`;
const BodyWrapper = styled.div`
    label: BodyWrapper;

    font-family: effra, sans-serif;
    font-size: 16px;
    font-weight: 400;

    letter-spacing: 0.144px;
    line-height: 32px;

    margin-bottom: 20px;
    margin-top: 20px;
`;

const PageSectionVideo = ({
    dataQa,
    direction,
    body,
    title,
    title_align,
    title_theme,
    title_type,
    mainTitle,
    mediaSrc,
    mediaThumbnailSrc,
    playButtonLabel,
    children
}) => {
    return (
        <PageSectionWrapper direction={direction} data-qa={`content-section-header-${dataQa}`}>
            <MediaWrapper>
                <Video title={title} thumbnailSrc={mediaThumbnailSrc} videoSrc={mediaSrc} />
            </MediaWrapper>
            <ContentWrapper>
                <TitleWrapper
                    data-qa={mainTitle ? `content-section-main-title-${dataQa}` : `content-section-title-${dataQa}`}
                    as={title_type === "page-title" ? "h1" : "h2"}
                    title_align={title_align}
                    title_type={title_type}
                    title_theme={title_theme}
                >
                    {title}
                </TitleWrapper>
                <BodyWrapper data-qa={`content-section-body-${dataQa}`}>{body}</BodyWrapper>
                <ChildContentWrapper>
                    <ButtonStyled
                        destination={mediaSrc}
                        new_window={false}
                        size="regular"
                        theme="blue_white"
                        text={playButtonLabel}
                    />
                    {children}
                </ChildContentWrapper>
            </ContentWrapper>
        </PageSectionWrapper>
    );
};

const PageSectionVideoPropTypes = {
    dataQa: PropTypes.string.isRequired,
    direction: PropTypes.oneOf(["content-left", "content-right"]),
    mediaSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    mediaThumbnailSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    playButtonLabel: PropTypes.string.isRequired,

    ...TitleWrapperPropTypes
};
PageSectionVideo.defaultProps = {
    direction: "content-left"
};
PageSectionVideo.propTypes = PageSectionVideoPropTypes;
export default PageSectionVideo;
